import React from "react";
import { FormatProvider } from "../../utils";
import AddEditFormats from "./AddEditFormats";

function AddEditForm() {
  return (
    <FormatProvider>
      <AddEditFormats />
    </FormatProvider>
  );
}

export default AddEditForm;
